import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "form"
  ]

  formTargetConnected() {
    this.stripe = Stripe(stripeKey, {stripeAccount: stripeAccountKey});

    // design Elements
    const style = {
      base: {
        color: "#555555",
        fontFamily: "Lato, Helvetica, Roboto, Arial, sans-serif",
        fontSize: "16px",
        fontSmoothing: "antialiased",
        lineHeight: "24px",
        "::placeholder": { color: "#999" },
        ":-webkit-autofill": { color: "#fce883" }
      }
    };

    // create Elements
    this.card = this.stripe.elements().create("card", {
      hidePostalCode: true,
      iconStyle: "default",
      style
    });

    // mount Elements in current DOM
    this.card.mount(document.getElementById("card-element"));

  }

  async submitForm(event) {
    event.preventDefault();

    const response = await fetch("/stripe/setup_intents/create_for_saved_card", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        authenticity_token: document.querySelector('meta[name="csrf-token"]').getAttribute("content")
      })
    })

    const parsedResponse = await response.json()

    const card = this.card;
    const result = await this.stripe.confirmCardSetup(parsedResponse.clientSecret, {payment_method: {card}})

    if (result.error) {
      // The setup has failed

      // show raised error and re-enable submit buttons
      this.showCardError(result.error.message);
      Ladda.stopAll();
    } else {
      // The setup has succeeded

      document.getElementById("stripe_payment_method_id").value = result.setupIntent.payment_method;

      // Update the stripe_setup_confirmed hidden field
      if (document.getElementById("stripe_setup_confirmed")) {
        document.getElementById("stripe_setup_confirmed").value = "1";
      }
      // Submit the form
      this.formTarget.submit();
    }
  }

  showCardError(message) {
    document.getElementById("card-errors").innerHTML = message;
  }
}
